// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Util_Css from "../../../util/Util_Css.bs.js";

var item = "teaserItem";

var img = "teaserImg";

var itemLink = "teaserItemLink";

var animatedTeaserClipRectSelector = "svg g rect";

var teaserImageIdentifier = Util_Css.createIdentifierSelector([img]);

var teaserItemIdentifier = Util_Css.createIdentifierSelector([item]);

var teaserItemLinkIdentifier = Util_Css.createIdentifierSelector([itemLink]);

function teaserImageSelector(param) {
  return CssJs.selector(teaserImageIdentifier, param);
}

function teaserItemsSelector(param) {
  return CssJs.selector(teaserItemIdentifier, param);
}

function teaserItemLinkSelector(param) {
  return CssJs.selector(teaserItemLinkIdentifier, param);
}

function teaserTitleSelector(param) {
  return CssJs.selector(animatedTeaserClipRectSelector, param);
}

var Selectors = {
  teaserImageIdentifier: teaserImageIdentifier,
  teaserItemIdentifier: teaserItemIdentifier,
  teaserItemLinkIdentifier: teaserItemLinkIdentifier,
  teaserImageSelector: teaserImageSelector,
  teaserItemsSelector: teaserItemsSelector,
  teaserItemLinkSelector: teaserItemLinkSelector,
  teaserTitleSelector: teaserTitleSelector
};

var panelHoverWrapper = "teaserHover";

var panelFocus = "teaserPanelFocus";

var hoverPlayButton = "teaserHoverPlayButton";

var moreOptionsButton = "teaserMoreOptionsButton";

var title = "teaserTitle";

var subtitle = "teaserSubtitle";

var hoverTitle = "teaserHoverTitle";

var hoverSubtitle = "teaserHoverSubtitle";

var hoverCloseButton = "teaserHoverCloseButton";

var hoverOverlay = "teaserHoverOverlay";

var link = "teaserItemLink";

export {
  item ,
  panelHoverWrapper ,
  panelFocus ,
  img ,
  hoverPlayButton ,
  moreOptionsButton ,
  itemLink ,
  title ,
  subtitle ,
  hoverTitle ,
  hoverSubtitle ,
  hoverCloseButton ,
  hoverOverlay ,
  link ,
  animatedTeaserClipRectSelector ,
  Selectors ,
}
/* teaserImageIdentifier Not a pure module */
